// src/services/authService.js
import axios from 'axios';

const API_URL = 'https://kortex-esp.phone.gs/vtigercrm/moncrm/agendaEspagne/api';

// Service d'authentification
const authService = {
  // Fonction de connexion
  login: async (username, password) => {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    
    const response = await axios.post(`${API_URL}/checkUser.php`, formData);
    
    if (response.data && response.data.success) {
      // Enregistrer les informations d'authentification
      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
      }
      
      // Stocker les informations utilisateur, y compris la filiale
      const userData = {
        username,
        filiale: response.data.filiale, // <-- Nouvelle propriété
        ...(response.data.user || {})
      };
      
      localStorage.setItem('user', JSON.stringify(userData));
      
      return response.data;
    }
    
    throw new Error(response.data.message || 'Échec de la connexion');
  },
  
  // Fonction de déconnexion
  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    
    // Redirection vers la page de connexion
    window.location.href = './login';
  },
  
  // Vérifier si l'utilisateur est connecté
  isAuthenticated: () => {
    const token = localStorage.getItem('authToken');
    const user = localStorage.getItem('user');
    return !!user && !!token;
  },
  
  // Récupérer le token
  getToken: () => {
    return localStorage.getItem('authToken');
  },
  
  // Récupérer les informations de l'utilisateur
  getUser: () => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  }
};

export default authService;
